module.exports = __webpack_public_path__ + "media/images/flags/1x1/bih-52c1096bdc4a8a5e315df1dc830a1b0d.svg";